module.exports = __webpack_public_path__ + "img/image_003.2217a000.png";